import React from "react";
import { useNavigate } from "react-router-dom";
import bgTunnelImg from "../assets/bg-tunnel.png";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full flex-grow flex flex-col items-center justify-center py-16 md:py-24 relative overflow-hidden">
      {/* Background image */}
      <img
        src={bgTunnelImg}
        className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
        alt=""
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1829]/0 via-[#0f1829]/50 to-[#0f1829] pointer-events-none" />

      {/* Orange glow orb */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-10 pointer-events-none"
        style={{ background: "radial-gradient(circle, #F05A22 0%, transparent 70%)" }}
      />

      {/* Content */}
      <div className="relative z-10 w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] max-w-[900px] mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#F05A22]/30 bg-[#F05A22]/10 text-[#F05A22] text-xs font-semibold mb-6 tracking-wide uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-[#F05A22] animate-pulse" />
          AI-Powered Career Tools
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.2rem] leading-tight text-white font-bold mb-6">
          Transform Your{" "}
          <span style={{ background: "linear-gradient(135deg, #F05A22, #E8407A)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
            MarTech Career
          </span>{" "}
          with AI-Powered Precision
        </h1>

        <p className="text-white/60 text-sm sm:text-base md:text-lg mb-10 max-w-[600px] mx-auto leading-relaxed">
          Achieve your professional goals with Angel, Anita, and Alfred — tools designed to
          optimize your CV, ace interviews, and master marketing operations effortlessly.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            className="px-8 py-3.5 text-white font-semibold rounded-xl text-base shadow-lg hover:scale-[1.03] transition-all"
            style={{ background: "linear-gradient(135deg, #F05A22, #E8407A)" }}
            onClick={() => navigate("/feature")}
          >
            Get Started Free
          </button>
          <button
            className="px-8 py-3.5 text-white/70 font-medium rounded-xl text-base border border-white/15 hover:bg-white/10 hover:text-white transition-all"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>
        </div>

        {/* Stats row */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 sm:gap-12">
          {[
            { value: "3", label: "AI Agents" },
            { value: "10k+", label: "Professionals" },
            { value: "98%", label: "Satisfaction" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl sm:text-3xl font-bold text-white">{stat.value}</p>
              <p className="text-white/40 text-xs mt-1 tracking-wide">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
